import { render, staticRenderFns } from "./IssueExtractionV2.vue?vue&type=template&id=e1fd9fe6&"
import script from "./IssueExtractionV2.vue?vue&type=script&lang=ts&"
export * from "./IssueExtractionV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports